import { react2angular } from 'react2angular';
import EmptyListPage from './index';

export const EmptyListPage2Module = angular
  .module('app.components.EmptyListPage2', [])
  .component('emptyListPage2', react2angular(EmptyListPage, null))
  .name;


// WEBPACK FOOTER //
// ./src/app/admin/components/EmptyListPage2/index.ng.js